
'use strict';


var isNumeric = function(n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
}
exports.isNumeric = function(n) {
    return isNumeric(n);
}

exports.isPercentage = function(per){
	if(!isNumeric(per)){
		return false
	}
	return (per >= 0 && per <= 100)
}

exports.percentageToNumber = function(per,total){
	return per*(total/100)
}

exports.numberToPercentage = function(num,total){
	return num/(total/100)
}

// http://davidwalsh.name/javascript-debounce-function
exports.debounce = function(func, wait, immediate) {
	// console.log("%%%%%%%%%%%%% DEBOUNCE")
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};



// WEBPACK FOOTER //
// ./src/js/lib/utils.js